const SubscriptionIndex = load('subscription/checkout/SubscriptionIndex')
const SubscriptionConfirmation = load('subscription/checkout/SubscriptionConfirmation')
const RecurringConfirmation = load('recurring/checkout/RecurringConfirmation')
import store from '../store'
import { load } from './component-loader';
const initialTitle = " | Eichlers  ";

export default[
    {
        path:"/subscription/:type_id/:group_id",
        name:"SubscriptionIndex",
        component:SubscriptionIndex,
        meta:{title:"Subscribe" + initialTitle},
        beforeEnter(to,from,next){  
            if(!store.getters['customer/isAuth']){
                localStorage.setItem("prevUrl",to.path);
                next({name:"Login"});
            }
            else{
              next()
            }
        }
    },
    {
        path:"/subscription-confirmation/:subscription_id",
        name:"SubscriptionConfirmation",
        component:SubscriptionConfirmation,
        meta:{title:"Subscription Confirmation" + initialTitle},
        props:true
    },
    {
        path:"/recurring-confirmation/:recurring_id",
        name:"RecurringConfirmation",
        component:RecurringConfirmation,
        meta:{title:"Subscription Confirmation" + initialTitle},
        props:true
    }
]


// WEBPACK FOOTER //
// ./resources/js/router/subscription.js